module.exports = __webpack_public_path__ + "static/media/audio-disabled.8467e78c.svg";